// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2DHdn","detailsBorder":"styles_detailsBorder__3fAQ6"};